// extracted by mini-css-extract-plugin
export default {"root":"SectionTitle_root__b90AV","rootTypeResults":"SectionTitle_rootTypeResults__2qnY-","rootTypeAboutMusOlymp":"SectionTitle_rootTypeAboutMusOlymp__aHGYg"};